import React from 'react';

import classes from './ProgressComponent.module.css';

import ProgressBar from '../ProgressBar/ProgressBar';
import Tooltip from '../../UI/Tooltip/Tooltip'
import ShowMiniLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';

const ProgressComponent = (props) => {

    const height = props.height ? props.height : null;
    const fontSize = props.fontSize ? props.fontSize : null;
    const borderColor = props.borderColor ? props.borderColor : null;
    const width = props.width ? props.width : null;


    return (
        <>
            <div className={classes.ProgressCard} style={{ height: height, fontSize: fontSize, borderColor: borderColor }}>

                {props.showLoader 
                ?
                    <ShowMiniLoader isLoading={true} transparentBg={true}/>
                :
                    props.type === 'Percentage'
                        ? <p className={classes.ProgressStat}>
                            {props.overallPercentage}
                            <span className={classes.PercentageSpan}>%</span>
                        </p>
                        : props.type === 'Fraction'
                            ? <p className={classes.ProgressStat}>
                                {props.fractionText[0]}
                                <span className={classes.FractionSpan}>/{props.fractionText[1]}</span>
                            </p>
                            : props.type === 'Number'
                                ? <p className={classes.ProgressStat}>{props.value} </p>
                                : <p className={classes.ProgressStat}>{props.overallPercentage}</p>
                }

                <p className={classes.ProgressText}
                    style={{ width: props.width?props.width:'', maxWidth: props.width? '70%':'50%' }}
                >{props.label}</p>

                {
                    props.showProgressBar
                        ? <div className={classes.ProgressBarDiv}>
                            <ProgressBar
                                styleclass={props.overallPercentage >= 80 ? "Green"
                                    : props.overallPercentage >= 70 ? "Yellow" : "Red"}
                                showProgressText={false} progress={props.overallPercentage} />
                        </div>
                        : null
                }
            </div>
            <div
                className={classes.TooltipContainer}>
                <Tooltip
                    show={props.showTooltip}
                    content={<p className={classes.SignUpFormTooltipText}>{props.tooltipMessage}</p>}
                    styleclass='ChangePasswordForm'
                    transparentBackdrop={true}
                    clicked={props.onTooltipClicked}
                    zIndex={2} />
            </div>
        </>
    );
}

export default ProgressComponent;